import { motion } from 'framer-motion';
import { Card } from '../../../design-system/components';

interface PersonaCardProps {
  emoji: string;
  title: string;
  description: string;
  index: number;
}

export default function PersonaCard({ emoji, title, description, index }: PersonaCardProps) {
  return (
    <motion.div
      className="ee-landing-cell"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.12 }}
    >
      <Card padding="lg" className="ee-landing-tile--center">
        <span className="ee-landing-tile__emoji" aria-hidden="true">
          {emoji}
        </span>
        <h3 className="ee-landing-tile__title">{title}</h3>
        <p className="ee-landing-tile__text">{description}</p>
      </Card>
    </motion.div>
  );
}
